import { render, staticRenderFns } from "./CompartirArchivo.vue?vue&type=template&id=6015fdaa&"
import script from "./CompartirArchivo.vue?vue&type=script&lang=js&"
export * from "./CompartirArchivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports